import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { IPublicClientApplication } from '@azure/msal-browser';
import { AppTheme, FormDef } from '../types';
import { dvList } from '../api/dataverseClient';

interface Props { pca: IPublicClientApplication; theme: AppTheme; }

export default function SubmitRequest({ pca }: Props) {
  const { projectId } = useParams();
  const [forms, setForms] = useState<FormDef[]>([]);
  const [loading, setLoading] = useState(true);
  const [selected, setSelected] = useState<FormDef | null>(null);

  useEffect(() => {
    const filter = projectId
      ? `_dagrun_pm_projectid_value eq ${projectId} and dagrun_pm_isactive eq true`
      : `dagrun_pm_isactive eq true`;
    dvList<FormDef>(pca, 'dagrun_pm_forms', {
      select: ['dagrun_pm_formid','dagrun_pm_name','dagrun_pm_formdescription','dagrun_pm_isactive','dagrun_pm_targetentitytype','_dagrun_pm_projectid_value'],
      filter,
    }).then(setForms).finally(() => setLoading(false));
  }, [pca, projectId]);

  if (loading) return <div className="page" style={{ maxWidth: 700 }}><div className="spinner" style={{ margin: '80px auto' }} /></div>;

  if (selected) {
    return (
      <div className="page" style={{ maxWidth: 700 }}>
        <h2 style={{ marginBottom: 16 }}>{selected.dagrun_pm_name}</h2>
        <div className="card" style={{ padding: 28 }}>
          <p style={{ color: 'var(--ink-3)', fontSize: 14, fontWeight: 300, marginBottom: 16 }}>
            {selected.dagrun_pm_formdescription}
          </p>
          <p style={{ color: 'var(--ink-4)', fontSize: 13 }}>
            Form submission — coming in Phase 10 detail.
          </p>
          <button className="btn-secondary" style={{ marginTop: 20 }} onClick={() => setSelected(null)}>Back</button>
        </div>
      </div>
    );
  }

  return (
    <div className="page" style={{ maxWidth: 700 }}>
      <h2 style={{ marginBottom: 24 }}>Submit Request</h2>
      {forms.length === 0 ? (
        <div className="card" style={{ padding: 48, textAlign: 'center', color: 'var(--ink-3)' }}>
          No active forms available.
        </div>
      ) : (
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))', gap: 12 }}>
          {forms.map(f => (
            <div key={f.dagrun_pm_formid} className="card"
              onClick={() => setSelected(f)}
              style={{ padding: 20, cursor: 'pointer', borderTop: '3px solid var(--brand)' }}>
              <strong style={{ fontSize: 15, color: 'var(--ink)' }}>{f.dagrun_pm_name}</strong>
              <p style={{ fontSize: 13, color: 'var(--ink-3)', marginTop: 8, fontWeight: 300 }}>
                {f.dagrun_pm_formdescription ?? ''}
              </p>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
